import React, { useEffect } from "react"
import { observer } from "mobx-react"
import { useStores } from "../../../helpers/useStores"
import BlockList from '../../common/BlockList'

const BridFooter = observer(props => {
    const { ArticleStore } = useStores();
    useEffect(() => {
        if (ArticleStore.bridOID === 0 || ArticleStore.bridOID === undefined) return;
        ArticleStore.fetchBridCategory(ArticleStore.bridOID)
    }, [])

    return <BlockList settings={ArticleStore.bridRecommendedTiles} />
})

export default BridFooter